import * as Sentry from "@sentry/react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAPpy47GZ7Jik-cCuQOjK6wKgVvThWyDuU",
  authDomain: "edubox-circulaire-economie.firebaseapp.com",
  projectId: "edubox-circulaire-economie",
  storageBucket: "edubox-circulaire-economie.appspot.com",
  messagingSenderId: "895102242037",
  appId: "1:895102242037:web:710f95f9b1edff36ab49bc",
};
firebase.initializeApp(firebaseConfig);

import "./index.css";
import App from "./app";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [],
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
